import type { CauserSubjectItem } from "./causer-subject.type";
import type { ModelKey } from "@/modules/model";

import { getModelLink } from "@/modules/model";

export const getCauserSubjectRoute = (
  model?: ModelKey,
  item?: CauserSubjectItem
) => {
  if (!model || !item || item.deleted_at !== null) return undefined;

  return getModelLink(model, item);
};
